// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PinFilledSubscriptIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="PinFilledSubscriptIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M15.004 5H5v2h2.5v3.822c-1.277.889-2.124 2.439-2.125 4.203v.5a1 1 0 0 0 1 1H9v3.479h2v-3.479h2.625a1 1 0 0 0 1-1v-.5c-.001-1.764-.848-3.314-2.125-4.203V7h2.504z" />
      <path d="m10 20.029-.185-.004h.37z" />
    </SvgIcon>
  );
});

/**
 * Usage only for within charts
 * @public
 */
export const PinFilledSubscriptIcon = /* @__PURE__ */ Object.assign(
  PinFilledSubscriptIconComponent,
  { displayName: 'PinFilledSubscriptIcon' },
);
